import { Provider } from '@angular/core';

/**
 * services
 */
import { UnitApiService } from './api';
import { UnitService } from './unit.service';

/**
 * Route-scoped provider bundle for unit read/write operations.
 *
 * Register on routes that inject {@link UnitService} (e.g. Control Board shell).
 * Does not include {@link UnitFormService} — provide that separately on the Units page.
 *
 * @example
 * ```typescript
 * providers: [...OtherProviders, ...UnitServiceProviders],
 * ```
 */
export const UnitServiceProviders: Provider[] = [
    UnitApiService,
    UnitService,
];
